app.init = function() {
    app.mobilemenu();
    app.frameit();
};

$(function() {
	app.init();
});